<template>
  <div class="w-full">
    <div class="container mx-auto grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-5 gap-5 lg:gap-8 place-items-start mb-10">
      <NearMeLocationCard
        v-for="location in nearMeStore.locations"
        :key="location.id"
        :location="location"
      />
    </div>

    <nav class="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6" aria-label="Pagination">
      <div class="hidden sm:block">
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">{{ nearMeStore.from }}</span>
          to
          <span class="font-medium">{{ nearMeStore.to }}</span>
          of
          <span class="font-medium">{{ nearMeStore.numberOfLocations }}</span>
          locations
        </p>
      </div>
      <div class="flex flex-1 justify-between sm:justify-end">
        <NuxtLink
          rel="prev"
          v-if="nearMeStore.showPreviousButton()"
          :to="previousPageLink"
          class="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >Previous</NuxtLink>
        <NuxtLink
          rel="next"
          v-if="nearMeStore.showNextButton()"
          :to="nextPageLink"
          class="relative ml-3 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >Next</NuxtLink>
      </div>
    </nav>
  </div>
</template>

<script setup>
const nearMeStore = useNearMeStore();
const regionStore = useRegionStore();
const route = useRoute();

const currentPage = computed(() => Number(route.query.page) || 1);

const basePath = computed(() => {
  const base = route.path;
  return `${base}?page=`;
});

const previousPageLink = computed(() => {
  return currentPage.value > 2 ? `${basePath.value}${currentPage.value - 1}` : route.path;
});

const nextPageLink = computed(() => {
  return `${basePath.value}${currentPage.value + 1}`;
});

async function fetchLocations() {
  await useAsyncData('near-me-locations', async () => {
    const location = regionStore.isRegion() ? regionStore.currentRegion : regionStore.currentCounty;
    if (regionStore.isRegion()) {
      await nearMeStore.fetchLocations(currentPage.value, null, location);
    } else {
      await nearMeStore.fetchLocations(currentPage.value, location);
    }
  });
}

await fetchLocations();

watch(
  () => route.query.page,
  async (newPage) => {
    window.scrollTo(0, 0);
    await fetchLocations();
  }
);
</script> 